import { useAnalytics } from 'src/modules/analytics/AnalyticsProvider';
import type { ActionName } from 'src/types';

export interface SalaryPreferenceTrackingData {
  actionName: ActionName;
  salaryCurrency: string;
}

export const useUpdateSalaryPreferenceAnalytics = () => {
  const { updateCard } = useAnalytics();

  const updateSalaryPreferenceAnalytics = (
    salaryPreferenceTrackingList: SalaryPreferenceTrackingData[],
  ) => {
    salaryPreferenceTrackingList.forEach(({ actionName, salaryCurrency }) =>
      updateCard({
        actionName,
        currentPageSection: 'next role',
        customProps: {
          currentPageSubsection: 'salary',
          salaryCurrency,
        },
      }),
    );
  };

  return { updateSalaryPreferenceAnalytics };
};
